/**
 * Window-event contract decoupling the transcript reader from the audio player.
 * The reader dispatches SEEK when a turn is clicked; the player listens and
 * jumps. The player dispatches PLAYHEAD on each timeupdate; the reader listens
 * to track the active segment. Using window events avoids threading callbacks
 * across the (separately-mounted) player + reader.
 */

/** Reader → player: jump audio to a position. */
export const TRANSCRIPT_SEEK_EVENT = 'nula:transcript:seek';

export interface TranscriptSeekEventDetail {
  startMs: number;
  recordingId: string;
}

/** Player → reader: current playback position (null = paused/ended). */
export const TRANSCRIPT_PLAYHEAD_EVENT = 'nula:transcript:playhead';

export interface TranscriptPlayheadEventDetail {
  recordingId: string;
  currentTimeMs: number | null;
}

export function dispatchTranscriptSeek(detail: TranscriptSeekEventDetail): void {
  window.dispatchEvent(new CustomEvent(TRANSCRIPT_SEEK_EVENT, { detail }));
}
